import React from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/solid';

const Accordion = ({ title, children, index, activeIndex, setActiveIndex })=> {
    const handleSetIndex = (index) => (activeIndex !== index) && setActiveIndex(index);
    return (
      <>
        <div onClick={() => handleSetIndex(index)} className='flex w-full justify-between p-2 mt-2 rounded bg-gray-100 cursor-pointer'>
            <div className='flex'>
                <div className='pl-5 text-2xl'>{title}</div>
            </div>
            <div className="flex items-center justify-center">
                {
                (activeIndex === index) 
                ? <ChevronDownIcon className='h-8 w-8 text-purple-900' />
                : <ChevronRightIcon className='h-8 w-8 text-purple-900' />
                }
            </div>
        </div>
        {(activeIndex === index) && (
            <div className="h-96 shadow-sm rounded-b-lg shadow-gray-500/50" style={{marginTop: 0, overflowY: "auto"}}>
              {children}
            </div>
        )}
      </>
    );
};

export default Accordion;